<div class="header" [ngClass]="isDarkmode ? 'darkmode' : 'forceDefaultColors'">
  <div class="dots-container">
    <div class="dots dots-1"></div>
    <div class="dots dots-2"></div>
    <div class="dots dots-3"></div>
  </div>
  <div class="url-container">
    <p class="url"><span class="grey">https://</span>sign.acme.com/fy8Ik34hnbs0q9</p>
  </div>
  <div class="body">
    <div class="body-left">
      <div>
        <div class="body-img">
          <img [src]="selectedLogoImageUrl || logo || whitelabelService.logo" alt="" />
        </div>
      </div>
      <div class="body-signers">
        <div class="body-signers-card">
          <app-blured-signer-card></app-blured-signer-card>
        </div>

        <div class="body-signers-card">
          <app-blured-signer-card></app-blured-signer-card>
        </div>
      </div>
    </div>
    <div class="body-right">
      <div class="body-right-header">
        <div class="body-right-title">
          <p class="body-right-title-text">{{ 'whitelabel.rentalAgreement' | translate }}</p>
          <p class="body-right-title-desc">{{ 'whitelabel.createdOnExample' | translate }}</p>
        </div>
        <div>
          <i class="fa-regular fa-ellipsis-v"></i>
        </div>
      </div>
      <div class="body-right-document forceDefaultColors">
        <app-blured-document></app-blured-document>
        <div class="body-right-button">
          <button type="button" class="document-action" [style.background]="mainColor" [style.box-shadow]="'0 5px 25px ' + mainColor" [style.color]="appService.getContrastColor(mainColor)">
            {{ 'button.sign' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
